import { QuestionnaireModel } from "../../../models/QuestionnaireModel";
import { setDefaultLanguage } from "../../../models/utilities/translationUtilities";
import { ActionTypes } from "../../actions/types";
import { QUESTIONNAIRE_CHANGED } from "../../actions";

export const questionnaireSliceReducer = (
    state: QuestionnaireModel,
    action: ActionTypes,
): QuestionnaireModel => {
    switch (action.type) {
        case QUESTIONNAIRE_CHANGED:
            setDefaultLanguage(action.questionnaire.defaultLanguage);
            return action.questionnaire;
        default:
            return state;
    }
};
